<nz-form-item class="pf-form-item">
    @if (!!label) {
        <nz-form-label
            class="pf-form-label"
            [nzRequired]="pfRequired"
            [nzNoColon]="true"
            [title]="label"
            [nzTooltipTitle]="tooltip"
            >{{ label }}
        </nz-form-label>
    }
    <nz-form-control
        class="pf-form-control"
        [nzErrorTip]="pfErrorTip"
        [nzValidateStatus]="
            validating ? 'validating' : !!control?.errors ? 'error' : ''
        ">
        @switch (typeProps?.type) {
            @case ("dateRange") {
                <nz-range-picker
                    class="pf-input"
                    [formControl]="formControl"
                    [nzRanges]="presetRanges"
                    [nzDisabled]="pfDisabled || loading"
                    [nzFormat]="dateFormat"
                    [nzPlaceHolder]="placeholder"
                    [nzShowTime]="
                        showTime
                            ? {
                                  nzUse12Hours: true,
                                  nzFormat: 'HH:mm'
                              }
                            : false
                    "
                    [nzStatus]="control?.errors ? 'error' : ''"
                    (nzOnCalendarChange)="calendarChangedHandler($event)">
                </nz-range-picker>
            }
            @case ("date") {
                <nz-date-picker
                    class="pf-input"
                    [nzDisabled]="pfDisabled || loading"
                    [nzFormat]="dateFormat"
                    [nzPlaceHolder]="placeholder"
                    [formControl]="formControl"
                    [nzShowTime]="
                        showTime
                            ? {
                                  nzUse12Hours: true,
                                  nzFormat: 'HH:mm'
                              }
                            : false
                    "
                    [nzStatus]="control?.errors ? 'error' : ''">
                </nz-date-picker>
            }
            @case ("time") {
                <nz-time-picker
                    class="pf-input"
                    [nzDisabled]="pfDisabled || loading"
                    [nzFormat]="timeFormat"
                    [nzUse12Hours]="true"
                    [nzPlaceHolder]="placeholder"
                    [formControl]="formControl"
                    [nzStatus]="control?.errors ? 'error' : ''">
                </nz-time-picker>
            }
        }
    </nz-form-control>
</nz-form-item>
